// Kayıtlı raporlar — yeni rapor eklemek için bu diziye obje ekle
const SAVED_REPORTS = [
  {
    id: "alici-borc",
    name: "Alıcı Borç",
    description: "Alıcı bazlı borç tutarları — bu ay, geçiken, gelecek KPI'lar",
    icon: "💳",
    componentType: "alici-borc",
  },
  {
    id: "satici-alacak",
    name: "Satıcı Alacak",
    description: "Satıcı bazlı alacak tutarları — bu ay, geçiken, gelecek KPI'lar",
    icon: "🏭",
    componentType: "satici-alacak",
  },
  {
    id: "nakit-akis",
    name: "Nakit Akış",
    description: "Tip/kod/isim bazlı, yıl-ay-gün kırılımlı filtrelenebilir nakit akış pivotu",
    icon: "💰",
    componentType: "nakit-akis",
  },
];

export default SAVED_REPORTS;
